import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../views/Start.vue'
import Instructions from '../views/Instructions.vue'
import Feedback from '../views/Feedback.vue'
import Play from '../views/Play.vue'
import Privacy from '../views/Privacy.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'start',
    component: Start,
    meta: {
      title: 'MapDrop | Start'
    }
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: Instructions,
    meta: {
      title: 'MapDrop | Anleitung'
    }
  },
  {
    path: '/play/:level([1-5])',
    name: 'play',
    component: Play,
    props: true,
    meta: {
      title: 'MapDrop | Spiel'
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'MapDrop | Über'
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {
      title: 'MapDrop | Feedback'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      title: 'MapDrop | Datenschutz'
    }
  },
  {
    path: '*',
    redirect: { name: 'start' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'MapDrop'
  next()
})

export default router
